import { createContext } from 'react';
import { Case } from 'API';
import { Updater } from 'use-immer';

type Props = [
  thisCase: Case | null,
  setThisCase: Updater<Case | null>,
];

const ProcessContext = createContext<Props>([null, () => {}]);

export default ProcessContext;
